module.exports = __webpack_public_path__ + "img/Abstract-poster.0bb52586.svg";